import { render, staticRenderFns } from "./LtkFollowButton.vue?vue&type=template&id=80622d78&scoped=true"
import script from "./LtkFollowButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkFollowButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LtkFollowButton.vue?vue&type=style&index=0&id=80622d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80622d78",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CBtnFollow: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CBtnFollow/CBtnFollow.vue').default,CBtnFollowIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CBtnFollowIcon/CBtnFollowIcon.vue').default,CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,CCard: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CCard/CCard.vue').default,CDialog: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CDialog/CDialog.vue').default})
